import React, { ReactElement, useMemo, useState, useCallback, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import { $k18n } from '@/common/i18n';
import LinearGradient from 'react-native-linear-gradient';
import { TouchableWithoutFeedback, Text, View, Dimensions, ScrollView, ViewStyle } from 'react-native';
import ImagePreview from '@kibt/meta-ui-krn/lib/components/ImagePreview';
import { debounce } from '@/common/utils/debounce';
import { useDetailPageStore } from '@/page/detail/store';
import Image from '@kds/image';
// 样式
import { convertStyles } from '@kibt/krn-utils';

import { KView, KText, PageContext } from '@/component/RtlLayout';
import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

import { getBuyShopStatus, PageRowData, Sku } from '../../../api';

import MyImage from '../MyImage';
import CloseWithBackground from '@/assets/icon_detail/closeWithBackground.png';
import ClosePng from '@/assets/icon_detail/close.png';
import IconDown from '@/assets/images_detail/icon-down.png';
import Popup from '@kibt/meta-ui-krn/lib/components/Popup';
import yoda from '@kibt/bridge';
import { openUrl } from '@/common/bridge/openUrl';
import { showFlashActivity, useGetSellerParams } from '@/page/detail/views/content/utils';

import { useJumpToConfirmOrder } from '../../../jump';

import { fromPrice } from '../../18nText';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import {
    logClickBuyNowSpec,
    logClickImgFullSwitch,
    logClickSelectNumber,
    logClickSelectSpec,
    logClickSpecImgContiner,
    logClickGoToDetail,
    logShowHalfSpecPage,
    logShowMessage,
    onSpecAddCartVisible,
    logClickSpecAddCart,
    logClickSpecHalfAddCart,
    logClickSpecHalfBuyButton,
} from '../../../logger2.0';
import CropImage from '@/business-components/CropImage';
import { isInApp, isIOS, isAndroid, isWeb, screenHeight, windowHeight, isMobileDeviceValue, PCMaxWidth } from '@/common/device-info';
import { useABHandler, useInstallmentFirstThresholdValue } from '../../../useABHandler';
import usePriceAfterCoupon from '@/hooks/abTest/usePriceAfterCoupon';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import { useFixedPosition, useIosFixedNativeID } from '@/hooks/useFixedPosition';
import { useQuery } from '@/hooks/useQuery';
import { useCallApp } from '@/common/callApp';
import { HorizontalGestureConflictView } from '@/component/HorizontalGestureConflictView';
import BottomAreaTip from '@/page/detail/views/content/components/BottomAreaTip';
import { ActivityType } from '../BigMarketingBanner/CaculateBlock';
import { useSubsidy } from '../../hooks/useSubsidy';
import { useLockBuyBtn } from '../../hooks/useLockBuyBtn';
import { useDebounceFn } from 'ahooks';
import { Toast } from '@kibt/meta-ui-krn';
import { radar, webLogger } from '@/common/log';
import { scaleW } from '@/common/style';
import { RenderSpecSelectArea } from './SpecSelectArea';
import { useSlideBack } from '@/hooks/useSlideBack';
import { isFixedViewSupport } from '@/component/FixedView';
import { FixedToast } from '@/component/FixedView/FixedToast';
import { reportCatchError } from '@/utils/reportCatchError';
import { useAbStore } from '@/store/useAbStore';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';

type IProps = {
    pageRawData: PageRowData;
    showDetailUrl?: string; // 直播间小黄车拉起规格半屏
    // changeStep: (num: GUIDE_ENUM) => () => void;
    closeSpec: (toast?: string) => void;
    isPopVisible: boolean;
    type: string;
    addCartItem?: (sku: any, num: number, sellerMerchantId?: any) => Promise<boolean>;
    foldRatio?: string | number;
    addToCartAnimation?: Function;
    // 是否展示修改数量的组件
    showChangeCount?: boolean;
    // 默认选中的规格
    defaultSelectedItems?: {
        [specId: string]: {
            [key: string]: any;
        };
    };
    onConfirm?: (sku: any, purchaseQuantity: number) => void;
    openHalfConfirmOrder?: boolean;
    autoBottomGap?: boolean;
    customDuration?: number;
    pageActiveStatus?: number;
    page?: string; //当前规格半屏页来源
    showAfterCouponPrice: boolean;
    isFrom?: string;
    // 同时展示加购和购买按钮（短视频凑单）
    showCartAndCheckout?: boolean;
    popupStyle?: any;
    retrievalInfo?: Record<any, string>;
    extParamsCustom?: any; // 如果别的页面引用多规格购买组件，可自定义传入跳转提单的归因来源
    ifUseDetailStore?: boolean; // 是否使用商详页的store
    isReco?: boolean; // 是否是reco的商品打开的规格半屏页
};
const SpecLine = forwardRef((props: IProps, ref): ReactElement => {
    const {
        pageRawData,
        closeSpec,
        isPopVisible,
        type, //  buy/cart/confirm
        addCartItem, // 触发外层加购接口
        foldRatio,
        addToCartAnimation,
        showDetailUrl = '',
        showChangeCount = true,
        openHalfConfirmOrder = false,
        autoBottomGap = false,
        customDuration = 150,
        pageActiveStatus,
        showAfterCouponPrice = false,
        isFrom,
        showCartAndCheckout = false,
        popupStyle = {},
        retrievalInfo,
        extParamsCustom,
        ifUseDetailStore = false,
        isReco = false,
    } = props;
    const { outterSpecImageIndex, outterPurchaseQuantity, outterCurrentSku } = useDetailPageStore(s => ({
        outterPurchaseQuantity: s.purchaseQuantity,
        outterSpecImageIndex: s.specImageIndex,
        outterCurrentSku: s.currentSku,
    }));
    const setStoreState = useDetailPageStore().setState;
    const getStoreState = useDetailPageStore().getState;
    const [specLinePopState, setSpecLinePopState] = useState({
        purchaseQuantity: 1,
        specImageIndex: -1,
        currentSku: {} as Sku,
    });

    const { setSlideBack } = useSlideBack();

    const { currentSku, purchaseQuantity, specImageIndex } = specLinePopState;
    const setPurchaseQuantity = num => {
        setSpecLinePopState(pre => ({
            ...pre,
            purchaseQuantity: num,
        }));
        if (ifUseDetailStore) getStoreState().setPurchaseQuantity(num);
    };

    const setCurrentSku = current => {
        setSpecLinePopState(pre => ({
            ...pre,
            currentSku: current,
        }));
        if (ifUseDetailStore) setStoreState({ currentSku: current });
    };

    const setSpecImageIndex = (index, changeSwiperIndex = true) => {
        setSpecLinePopState(pre => ({
            ...pre,
            specImageIndex: index,
        }));
        if (ifUseDetailStore) {
            // 如果不是商详页当前的商品规格半屏，不修改swiper的index
            if (!isNotAllImg && ifUseDetailStore) {
                if (index > -1) {
                    setStoreState({
                        swiperImageIndex: getStoreState().showVideo
                            ? getStoreState().detailImageurls.length + index + 1
                            : getStoreState().detailImageurls.length + index,
                        specImageIndex: index,
                    });
                } else {
                    setStoreState({ specImageIndex: -1 });
                    if (changeSwiperIndex) setStoreState({ swiperImageIndex: 0 });
                }
            } else {
                setStoreState({
                    specImageIndex: index,
                });
            }
        }
    };

    useEffect(() => {
        if (ifUseDetailStore) {
            setSpecLinePopState({
                currentSku: outterCurrentSku,
                purchaseQuantity: outterPurchaseQuantity,
                specImageIndex: outterSpecImageIndex,
            });
        }
    }, [outterCurrentSku, outterPurchaseQuantity, outterSpecImageIndex, ifUseDetailStore]);
    const { detailABValueMap } = useABHandler();
    const minNum = (pageRawData?.minPurchase as number) ?? 1;
    const showUpStepper = detailABValueMap?.if_spec_num_up && isFrom === 'detail';

    const skuSpecTypes = [
        { label: $k18n({ id: 'k_226117', text: '规格' }), value: 1 },
        { label: $k18n('颜色'), value: 2 },
        { label: $k18n('图案'), value: 3 },
        { label: $k18n('材质'), value: 5 },
        { label: $k18n('口味'), value: 6 },
        { label: $k18n('色号'), value: 7 },
        { label: $k18n('容量'), value: 8 },
        { label: $k18n('度数'), value: 9 },
        { label: $k18n('功效'), value: 10 },
        { label: $k18n('型号'), value: 11 },
        { label: $k18n('内存'), value: 12 },
        { label: $k18n('尺寸'), value: 13 },
        { label: $k18n('重量'), value: 14 },
        { label: $k18n('厚度'), value: 15 },
        { label: $k18n('适用肤质'), value: 16 },
        { label: $k18n('使用人群'), value: 17 },
        { label: $k18n('适用性别'), value: 18 },
        { label: $k18n('适用年纪'), value: 19 },
        { label: $k18n('适用季节'), value: 20 },
        { label: $k18n('货号'), value: 21 },
        { label: $k18n('尺'), value: 22 },
        { label: $k18n('款式'), value: 23 },
    ];
    const skuSpecTypesMap = {};
    skuSpecTypes?.forEach(item => {
        skuSpecTypesMap[item.value] = item.label;
    });

    // 对接口返回的原始数据进行改造
    const specs = useMemo(
        () =>
            pageRawData.specs
                ? pageRawData.specs.map(item => {
                      if (item) {
                          item.specName = skuSpecTypesMap[item.specId] || item.specName;
                          item.label = item.specName;
                          item.value = item.specId;
                          const content = item.itemSpecValues.map(specItem => {
                              specItem.label = specItem.specValueName;
                              specItem.value = specItem.specValueId;
                              return specItem;
                          });
                          item.content = content;
                          return item;
                      }
                  })
                : [],
        [pageRawData.specs]
    );

    const skuInfo = useMemo(() => {
        return pageRawData.skus
            ? pageRawData.skus.map((sku: { skuSpecs: any[] }) => {
                  const skuInfoItem = {};
                  sku.skuSpecs.forEach(spec => {
                      skuInfoItem[spec.specId] = spec.specValueId;
                  });
                  return {
                      ...skuInfoItem,
                      ...sku,
                  };
              })
            : [];
    }, [pageRawData.skus]);

    const selectionList = specs;

    const types = {};
    selectionList.map(item => {
        const key = item?.value;
        if (key) types[key] = null;
    });
    const [selectedKV, setSelectedKV] = useState(types);

    const containerHeightState = useDraggableHeight();
    // 初始化规格区轮播图 第一张主图 + 所有的规格图
    const isNotAllImg = !pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl || pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl === '';

    // 如果筛选规格第一行的每个规格， 都有规格图
    const specImageUrls = useMemo(() => {
        const productMainImage = pageRawData && pageRawData.imageUrls && pageRawData.imageUrls[0];
        // 图片优化的主图
        const productMainImageOpt = pageRawData && pageRawData.templateImageUrls && pageRawData.templateImageUrls[0];
        const imageArr = [productMainImageOpt || productMainImage];

        if (pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl && pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl !== '')
            pageRawData.specs[0].itemSpecValues?.forEach(item => {
                imageArr.push(item.templateImageUrl || item.imageUrl);
            });

        return [...imageArr];
    }, [pageRawData]);

    const [showImageViewer, setShowImageViewer] = useState(false);
    useEffect(() => {
        if (!isPopVisible) setShowImageViewer(false);
    }, [isPopVisible]);

    const clickImgPre = () => {
        setShowImageViewer(true);
        setTimeout(() => setSlideBack(false));
        logClickSpecImgContiner(pageRawData.itemId);
    };

    // 用来存储选中的规格参数
    const selectedItems = useMemo(() => {
        const res = [];
        Object.keys(selectedKV).map(specId => {
            const value = selectedKV[specId];
            if (!value) return;
            const spec = specs?.find(_spec => String(_spec?.value) === String(specId)) || {};
            const targetSpec = spec.itemSpecValues?.find(itemSpecValue => itemSpecValue.specValueId === value);
            res.push(targetSpec);
        });
        return res;
    }, [selectedKV, specs]);

    const clearFirstLineSpec = () => {
        const specId = selectionList?.[0]?.specId;
        if (specId) {
            selectedKV[specId] = null;
            setSelectedKV({ ...selectedKV });
        }
    };

    // 命中商详页返回时引导加购弹窗时，增加'popup'类型的埋点上报
    const addType = getStoreState()?.alertVisible?.specPupoup ? 'popup' : '';
    // 关闭引导弹窗时，重置type
    const resetAlertVisibleType = () => {
        getStoreState().setAlertVisible({
            ...getStoreState().alertVisible,
            specPupoup: false,
        });
    };

    const isDisabled = (item, type) => {
        // 自营测品 放开限制
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            return false;
        }
        const key = type?.value;
        const value = item?.value;
        const selectedReplaced = JSON.parse(JSON.stringify(selectedKV));
        if (key) selectedReplaced[key] = value;

        const flag = skuInfo.some(skuItem => {
            return Object.keys(selectedKV).every(key => {
                if (selectedReplaced[key]) {
                    // 库存小于最低加购时，不能选
                    return skuItem[key] === selectedReplaced[key] && skuItem.availableQuantity >= minNum;
                }
                return true;
            });
        });

        return !flag;
    };

    useEffect(() => {
        // specImageIndex只影响主规格
        if (!ifUseDetailStore) return;
        setSpecImageIndex(outterSpecImageIndex, false);
        if (outterSpecImageIndex === -1) {
            selectedKV[selectionList?.[0]?.value] = null;
            setSelectedKV({ ...selectedKV });
            setCurrentSku({});
            return;
        }
        const _type = selectionList?.[0];
        const item = selectionList?.[0]?.content?.[outterSpecImageIndex];
        const key = _type?.value; // 具体是 重量
        const value = item?.value; // 具体是 1kg 2kg

        // 修改选中项
        const sameSpecId = selectedItems.findIndex(spec => item?.specId === spec?.specId && item.specValueId === spec.specValueId);
        if (sameSpecId === -1) {
            if (selectedKV[key] !== value) {
                selectedKV[key] = value;
                setSelectedKV({ ...selectedKV });
                if (item && _type && isDisabled(item, _type)) {
                    // 如果不是切换图片就弹出toast提示
                    // showToast({
                    //     text: $k18n('抱歉，商品已售罄'),
                    //     duration: 1000,
                    // });
                    logShowMessage(pageRawData.itemId, 2);
                }
            }
        }
        const current = skuInfo.find(skuItem => {
            if (Object.keys(selectedKV).length) {
                return Object.keys(selectedKV).every(key => {
                    return selectedKV[key] === skuItem[key];
                });
            } else {
                return false;
            }
        });
        if (current) {
            setCurrentSku(current);
        } else {
            setCurrentSku({});
        }
        const quantity = immediateAvailableQuantity;
        if (Number(quantity) > 0 && Number(quantity) < minNum) {
            Toast.show({ text: $k18n('抱歉，商品已售罄') });
        }
    }, [ifUseDetailStore, outterSpecImageIndex]);

    useEffect(() => {
        if (props.defaultSelectedItems) {
            selectionList.forEach((type, level) => {
                const curSpec = props.defaultSelectedItems[type?.specId];
                if (curSpec) {
                    const selectedValueIndex = type.content.findIndex(item => item.specValueId === curSpec.specValueId);
                    if (selectedValueIndex !== -1) {
                        const item = type.content[selectedValueIndex];
                        selectItem(item, type, level, selectedValueIndex, false);
                    }
                }
            });
        }
    }, [props.defaultSelectedItems]);

    // 动态库存
    const immediateAvailableQuantity = useMemo(() => {
        const res = [] as any;
        skuInfo.forEach(skuItem => {
            const flag = selectedItems.every(item => item && skuItem[item?.specId] === item.specValueId);
            if (flag) {
                res.push(skuItem);
            }
        });
        const availableQuantity = res.reduce((cur, next) => {
            return cur + next.availableQuantity;
        }, 0);
        return availableQuantity;
    }, [skuInfo, selectedItems]);

    const selectItem = (item, type, level, index, canSelect = true) => {
        // 有重新勾选规格的行为，就要把购买数量重置为最低起购
        const watchSelectedIndex = _specImageIndex => {
            setSpecImageIndex(_specImageIndex);
        };
        setPurchaseQuantity(minNum);
        // 如果选择的是第一行的规格
        if (level === 0) {
            // index 是规格的位置，specImageIndex是被选中规格的位置
            // 相等说明是，取消选中
            if (index === specImageIndex) {
                watchSelectedIndex(-1);
            } else {
                // 不相等说明是，更换选中
                watchSelectedIndex(index);
            }
        }

        logClickSelectSpec();
        const key = type?.value; // 具体是 重量
        const value = item?.value; // 具体是 1kg 2kg

        // 修改选中项
        if (selectedKV[key] !== value) {
            selectedKV[key] = value;
            setSelectedKV({ ...selectedKV });
            if (canSelect) {
                logShowMessage(pageRawData.itemId, 2);
            }
        } else {
            selectedKV[key] = null;
            setSelectedKV({ ...selectedKV });
        }
        const current = skuInfo.find(skuItem => {
            if (Object.keys(selectedKV).length) {
                return Object.keys(selectedKV).every(key => {
                    return selectedKV[key] === skuItem[key];
                });
            } else {
                return false;
            }
        });
        if (current) {
            setCurrentSku(current);
        } else {
            setCurrentSku({});
        }
        const quantity = immediateAvailableQuantity;
        if (Number(quantity) > 0 && Number(quantity) < minNum) {
            Toast.show({ text: $k18n('抱歉，商品已售罄') });
        }
    };

    const isActive = (item, type) => {
        const key = type?.value;
        const value = item?.value;
        return key && value && selectedKV[key] === value;
    };

    const { hasSubsidy } = useSubsidy();
    const { lockRef, setLock } = useLockBuyBtn();
    const { jumpToConfirmOrder } = useJumpToConfirmOrder();
    const { sellerMerchantId: sellerMerchantIdFromQuery, sellerUserId: sellerUserIdFromQuery } = useGetSellerParams();
    const onJumpToConfirmOrder = async ({ addressId, buyamount, merchantId, skuId, itemId, poc, needDelay1 = false, backendDispatchUrl = '' }) => {
        if (lockRef.current) {
            webLogger.sendLog({
                type: 'click',
                name: 'dumplicateSubmit',
                value: {
                    page: 'Detail:SpecLinePop',
                    status: 0,
                    time: Date.now(),
                },
            });
            return;
        }
        webLogger.sendLog({
            type: 'click',
            name: 'dumplicateSubmit',
            value: {
                page: 'Detail:SpecLinePop',
                status: 1,
                time: Date.now(),
            },
        });
        setLock(true);
        const needDelay = false;
        const flashSaleActivityId =
            pageRawData?.activityInfo?.activityId && pageRawData?.activityInfo?.status === 2 && pageRawData?.activityInfo?.saleRate < 100
                ? pageRawData?.activityInfo?.activityId
                : 0;

        const subsidyItem = pageRawData?.activityList?.find(v => v?.marketingActivityType === ActivityType.Exclusive);

        jumpToConfirmOrder({
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            sellerMerchantId: sellerMerchantIdFromQuery,
            sellerUserId: sellerUserIdFromQuery,
            poc,
            needDelay,
            flashSaleActivityId,
            halfWebview: openHalfConfirmOrder,
            minPurchase: minNum,
            retrievalInfo,
            extParamsCustom,
            backendDispatchUrl,
            ...(hasSubsidy && subsidyItem
                ? {
                      promotionId: subsidyItem.activityId,
                      afterDiscountPrice: currentSku.activityPrice ?? pageRawData.activityPrice,
                  }
                : {}),
        });
    };

    const comfirmDisabled = !Object.keys(selectedKV).every(key => {
        return selectedKV[key] !== null;
    });

    const isToBDetail = useQuery('pageType') === 'seller';
    const queryItemId = useQuery('itemId');
    const extParams = useQuery<string>('extParams');
    const mainTypeScrollViewRef = useRef<ScrollView>();
    useEffect(() => {
        if (specImageIndex === -1) return;
        const mainTypeCount = pageRawData?.specs?.[0]?.itemSpecValues?.length || 0;
        const columns = Math.ceil(mainTypeCount / 2);
        mainTypeScrollViewRef.current?.scrollTo({ x: ((specImageIndex % columns) - 1) * scaleW(128) });
    }, [specImageIndex, pageRawData?.specs]);

    const descPurchaseQuantity = () => {
        // logClickBuyNow(1);
        logClickSelectNumber('0');
        if (purchaseQuantity !== 1 && purchaseQuantity <= minNum) {
            Toast.show({ text: $k18n({ id: 'k_251870', text: '最少购买{x}件', params: { x: minNum } }) });
            return;
        }
        if (purchaseQuantity === 1) {
            logShowMessage(pageRawData.itemId, 1);
            Toast.show({
                text: $k18n('商品不能再少啦'),
                duration: 1000,
            });
            return;
        }
        const newPurchaseQuantity = purchaseQuantity - 1;
        setPurchaseQuantity(newPurchaseQuantity);
    };

    const skuOverActivityLimit =
        pageRawData?.activityInfo?.activityId &&
        showFlashActivity(pageRawData?.activityInfo?.status) &&
        pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId] >= 0 &&
        purchaseQuantity > pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId];

    useEffect(() => {
        // 秒杀商品部分sku达到限购时（banner位的图片轮播切换、预览切换、主界面价格组件切换规格，规格半屏切换规格）
        if (
            pageRawData?.activityInfo?.activityId &&
            [2, 4, 5].includes(pageRawData?.activityInfo?.status) &&
            pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId] === 0
        ) {
            FixedToast.show({
                text: $k18n({ id: 'k_407823', text: '抱歉，您已达该规格活动购买上限，去看看其他规格' }),
                duration: 1000,
            });
            return;
        }
    }, [currentSku, pageRawData?.activityInfo?.activityId, pageRawData?.activityInfo?.status]);

    const buyNowStatus = async (itemId, skuId) => {
        let flag = true;

        const ext = extParams || '';

        await getBuyShopStatus({
            itemId,
            skuId,
            extParams: ext,
            sellerUserId: Number(sellerUserIdFromQuery || 0),
            merchantId: Number(sellerMerchantIdFromQuery || 0),
        })
            .then(res => {
                if (
                    res.data.shopStatus === 2 ||
                    res.data.shopBusinessStatus === 2 ||
                    res.data.stock <= 0 ||
                    res.data.activeStatus !== 2 ||
                    res.data.auditStatus !== 2
                ) {
                    flag = false;
                    if (res.data.shopBusinessStatus === 1 && res.data.shopStatus === 1) {
                        if (res.data.activeStatus !== 2 && res.data.auditStatus === 2) {
                            Toast.show({
                                text: $k18n('抱歉，商品已下架'),
                                duration: 3000,
                            });
                        } else if (res.data.activeStatus === 2 && res.data.auditStatus === 2 && res.data.stock <= 0) {
                            Toast.show({
                                text: $k18n('抱歉，商品已售罄'),
                                duration: 3000,
                            });
                        } else {
                            Toast.show({
                                text: $k18n('糟糕！商品找不到啦'),
                                duration: 3000,
                            });
                        }
                    } else {
                        Toast.show({
                            text: $k18n('糟糕！商品找不到啦'),
                            duration: 3000,
                        });
                    }
                }
            })
            .catch(err => {
                // context.emit('changLoding', false);
                flag = false;
                // 全局拦截器处理错误提示
                // showToast({
                //     text: (err.message as string)?.substring(0, 100),
                //     duration: 3000,
                // });
            });

        return flag;
    };

    const { callApp } = useCallApp();
    const buyNow = async () => {
        console.log('lock:::buyNow', lockRef.current);
        if (lockRef.current) {
            Toast.show({ text: $k18n('您的操作太频繁了') });
            return;
        }

        const skuId = currentSku.skuId;
        const skuSpecDesc = currentSku.skuSpecDesc;
        if (!skuId) {
            return;
        }
        // 购买数量超出秒杀限购的数量时，购买按钮置灰不可点
        if (skuOverActivityLimit) {
            return;
        }
        if (Number(immediateAvailableQuantity) === 0) {
            return;
        }
        // // 端外购买的话 需要唤起端内
        // if (!isInApp) {
        //     return callApp({ pageId: 'ecomm_commodity_detail' });
        // }

        // 未登陆需要登陆
        // const res = await yoda.component.login({});
        // if (res?.result !== 1) {
        //     return;
        // }
        const { merchantId, itemId } = currentSku;
        const buyamount = Math.max(purchaseQuantity, purchaseQuantity);
        const addressId = getStoreState().addressInfo?.addressId;

        const is_with_coupon = pageRawData.discountCoupon && pageRawData.discountCoupon.length > 0 ? 1 : 0; // 是否是优惠券商品的购买
        const coupon_id = pageRawData.discountCoupon && pageRawData.discountCoupon.length > 0 ? `${pageRawData.discountCoupon[0].batchId}` : ''; // 券批次ID
        logClickBuyNowSpec(itemId, skuSpecDesc, skuId, coupon_id, is_with_coupon);
        onJumpToConfirmOrder({
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            poc: 'spec_1',
            backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
        });
    };

    // const onThrottledBuyNow = () => {
    //     buyNow();
    // };

    const { run: onThrottledBuyNow } = useDebounceFn(
        () => {
            buyNow();
        },
        {
            leading: true,
            trailing: false,
            wait: 500,
        }
    );

    const addToCart = async () => {
        // 规格业务埋点监控

        radar.event({
            name: 'common_spec_confirm_click',
        });
        // 端外购买的话 需要唤起端内
        if (!isInApp) {
            return callApp({ pageId: 'ecomm_commodity_detail' });
        }

        // 未登陆需要登陆
        const res = await yoda.component.login({});
        if (res?.result !== 1) {
            return;
        }

        const skuId = currentSku.skuId;
        if (!skuId) {
            return;
        }
        if (Number(immediateAvailableQuantity) === 0) {
            if (!pageRawData?.extraInfo?.selfOperated && type === 'cart') {
                return;
            }
        }
        const { itemId } = currentSku;
        const buyamount = Math.max(purchaseQuantity, purchaseQuantity);

        logClickSpecAddCart({
            item_id: itemId,
            sku_id: skuId,
            sku_num: buyamount,
            type: addType,
            source: Number(queryItemId) === Number(pageRawData.itemId) ? 'current' : isReco ? 'recommend' : '',
            releated_item_id: String(queryItemId),
        });
        resetAlertVisibleType();

        let shopFlag;
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            shopFlag = true;
        } else {
            shopFlag = await buyNowStatus(itemId, skuId);
        }

        if (shopFlag) {
            // 调用外层加入购物车接口
            const result = await addCartItem?.(currentSku, buyamount);
            if (result && addToCartAnimation) {
                addToCartAnimation();
            }
            return result;
        }
        return false;
    };
    const onThrottledAddCart = useCallback(
        debounce(() => {
            addToCart();
        }, 200),
        [buyNow]
    );
    const { run: debounceConfirm } = useDebounceFn(
        _disabled => {
            // 规格业务埋点监控
            radar.event({
                name: 'common_spec_confirm_click',
            });
            if (_disabled) return;
            props.onConfirm?.(currentSku, purchaseQuantity);
        },
        { wait: 200 }
    );
    // showCartAndCheckout 是有外层控制是否展示规格半屏多按钮；当showCartAndCheckout为true时，并且需要满足当前商品总价达到运费券门槛，才真正展示多按钮。
    const innerShowCartAndCheckout = useMemo(() => {
        if (currentSku?.skuId && pageRawData.abTest?.multipulButtonForSpecHalfScreen) {
            if (currentSku?.activityPrice * purchaseQuantity >= pageRawData?.shippingFeeView?.threshold && pageRawData.shippingFeeView?.threshold) {
                return true;
            }
        }
        return false;
    }, [purchaseQuantity, currentSku, pageRawData]);

    const renderOptionBarButton = () => {
        let disabled;
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            disabled = comfirmDisabled || skuOverActivityLimit;
        } else {
            // 库存小于最小起购，购买置灰
            disabled =
                Number(immediateAvailableQuantity) === 0 || Number(immediateAvailableQuantity) < minNum || comfirmDisabled || skuOverActivityLimit;
        }

        const rtlClassName = ['optionbar_bar_bottom_btn', disabled ? 'optionbar_bar_bottom_btn_disabled' : ''];
        const miniBtnClassName = ['optionbar_bar_bottom_btn_mini', disabled ? 'optionbar_bar_bottom_btn_mini_disabled' : ''];
        const primaryMiniBtnClassName = ['optionbar_bar_bottom_btn_mini_primary', disabled ? 'optionbar_bar_bottom_btn_mini_disabled' : ''];

        const bottomAreaTip = (
            <BottomAreaTip
                {...{
                    pageRawData,
                    isFrom: isFrom,
                    showCouponMakeUpTip: showCartAndCheckout && innerShowCartAndCheckout,
                    position: 'specLinePop',
                }}
            />
        );

        const buttons = {
            buy: (
                <View>
                    {/* 底部按钮上方的提示文案 */}
                    {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                        <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView>
                    ) : null}
                    <KTouchableWithoutFeedback onPress={onThrottledBuyNow}>
                        <KView rtlClassName={rtlClassName} style={{ width: isMobileDeviceValue ? '376px' : '356px' }}>
                            <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('购买')}</KText>
                        </KView>
                    </KTouchableWithoutFeedback>
                </View>
            ),
            cart: (
                <View>
                    {showCartAndCheckout && innerShowCartAndCheckout ? (
                        <>
                            {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                                <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView>
                            ) : null}
                            <KView rtlClassName={'optionbar_bar_btn_wrapper'}>
                                <KTouchableWithoutFeedback
                                    onPress={() => {
                                        onThrottledAddCart();
                                        // 只有规格半屏内既有加购，又有购买时点击加购才上报这个埋点；
                                        logClickSpecHalfAddCart(pageRawData?.itemId);
                                    }}>
                                    <KView rtlClassName={miniBtnClassName}>
                                        <KText rtlClassName={'optionbar_bar_bottom_btn_black_text'}>
                                            {$k18n({ text: '加入购物车', id: 'k_355118' })}
                                        </KText>
                                    </KView>
                                </KTouchableWithoutFeedback>
                                <KTouchableWithoutFeedback
                                    onPress={() => {
                                        onThrottledBuyNow();
                                        // 只有规格半屏内既有加购，又有购买时点击购买才上报这个埋点；
                                        logClickSpecHalfBuyButton(pageRawData?.itemId);
                                    }}>
                                    <KView rtlClassName={primaryMiniBtnClassName}>
                                        <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('购买')}</KText>
                                    </KView>
                                </KTouchableWithoutFeedback>
                            </KView>
                        </>
                    ) : (
                        <>
                            {/* 底部按钮上方的提示文案 */}
                            {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                                <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView>
                            ) : null}
                            <KTouchableWithoutFeedback onPress={() => onThrottledAddCart()}>
                                <KView rtlClassName={rtlClassName}>
                                    <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>
                                        {$k18n({ text: '加入购物车', id: 'add_to_cart' })}
                                    </KText>
                                </KView>
                            </KTouchableWithoutFeedback>
                        </>
                    )}
                </View>
            ),
            confirm: (
                <KTouchableWithoutFeedback onPress={() => debounceConfirm(disabled)}>
                    <KView rtlClassName={rtlClassName}>
                        <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('确定')}</KText>
                    </KView>
                </KTouchableWithoutFeedback>
            ),
        };

        return (
            <KView rtlClassName={'optionbar_bar'} style={{ paddingBottom: isIOS ? scaleW(30) : scaleW(10) }}>
                <LinearGradient
                    style={{"width":"100%","height":"0.9661835748792271rem","position":"absolute","top":"-0.9661835748792271rem"}}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 0, y: 1 }}
                    colors={['rgba(255, 255, 255, 0)', 'rgba(0, 0, 0, 0.07)']}
                />
                {buttons[type] || buttons.cart}
            </KView>
        );
    };
    const selectedItemsLabels = useMemo(() => {
        let specsStr = '';
        selectionList.forEach(_specs => {
            const spec = selectedItems?.find(selectedItem => String(selectedItem?.specId) === String(_specs?.specId));
            if (spec) specsStr = `${specsStr}${spec.label}, `;
        });
        specsStr = specsStr.substring(0, specsStr.length - 2);
        return `${specsStr}`;
    }, [selectedItems, selectionList]);

    useEffect(() => {
        if (ifUseDetailStore)
            setStoreState({
                immediateAvailableQuantity: immediateAvailableQuantity,
            });
    }, [immediateAvailableQuantity, ifUseDetailStore, setStoreState]);

    const [isFlashProduct, isAfterUsingCoupon] = useMemo(() => {
        return [pageRawData.salePriceInclude?.includes('FLASH_SALE'), pageRawData.salePriceInclude?.includes('COUPON')];
    }, [pageRawData.salePriceInclude]);

    const { priceAfterCoupon } = usePriceAfterCoupon();

    // 动态价格
    const immediateDisplayPrice = useMemo(() => {
        const res = [] as any;
        skuInfo.forEach(skuItem => {
            // 备注： 若收到一个空数组，此方法在任何情况下都会返回 true。
            // 所以在没有选择 规格 的情况下 就是把当前商品的所有sku都push到res中。
            const flag = selectedItems.every(item => {
                return item && skuItem[item.specId] === item.specValueId;
            });
            if (flag) {
                /* 达人商详页不展示分期信息 */
                const installment = isToBDetail ? {} : pageRawData.skuInstallments?.find(_installment => _installment.skuId === skuItem.skuId) || {};
                res.push({ ...skuItem, installment });
            }
        });
        if (!res.length) {
            return {};
        }
        // 券后价和秒杀价的取值逻辑是一样的，只是取用的字段不一样
        // 商品命中展示券后价实验 || 商详页展示displaySalePrice(showAfterCouponPrice = true)
        // 商品参加活动时，展示秒杀价
        if (
            (isAfterUsingCoupon && priceAfterCoupon.showPriceUsedCouponStyle) ||
            showAfterCouponPrice ||
            (pageRawData?.activityInfo?.activityId &&
                showFlashActivity(pageRawData?.activityInfo?.status) &&
                pageRawData?.activityInfo?.saleRate <= 100)
        ) {
            const typePrice = {
                afterCoupon: {
                    itemPrice: 'salePrice',
                    displayPrice: 'displaySalePrice',
                },
                flashSale: {
                    itemPrice: 'activityPrice',
                    displayPrice: 'displayActivityPrice',
                },
            };
            const targetPrice = !showAfterCouponPrice ? typePrice.flashSale : typePrice.afterCoupon;
            // 对所有的sku 进行价格排序
            const sortedRes = res.sort((a, b) => a[targetPrice.itemPrice] - b[targetPrice.itemPrice]);
            // 如果价格不一样 展示 100起 这种
            if (sortedRes[0] && sortedRes[0][targetPrice.itemPrice] === sortedRes[sortedRes.length - 1][targetPrice.itemPrice]) {
                return {
                    price: sortedRes[0][targetPrice.itemPrice],
                    displayPrice: sortedRes[0][targetPrice.displayPrice],
                    node: <Text style={{"fontSize":"4.830917874396135rem","fontWeight":"700","color":"#FF4906"}}>{sortedRes[0][targetPrice.displayPrice]}</Text>,
                    ifAllSame: true,
                    installmentInfo: sortedRes[0].installment,
                };
            }
            return {
                price: sortedRes[0]?.[targetPrice.itemPrice],
                displayPrice: sortedRes[0]?.[targetPrice.displayPrice],
                node: <Text style={{"fontSize":"4.830917874396135rem","fontWeight":"700","color":"#FF4906"}}>{sortedRes[0]?.[targetPrice.displayPrice]}</Text>,
                ifAllSame: false,
                installmentInfo: sortedRes[0]?.installment,
            };
        }
        // 对所有的sku 进行价格排序
        const sortedRes = res.sort((a, b) => a.skuPrice - b.skuPrice);
        // 如果价格不一样 展示 100起 这种
        if (sortedRes[0] && sortedRes[0].displaySkuPrice === sortedRes[sortedRes.length - 1].displaySkuPrice) {
            return {
                price: sortedRes[0].skuPrice,
                displayPrice: sortedRes[0].displaySkuPrice,
                node: <KText rtlClassName={'product-price-display-text'}>{sortedRes[0].displaySkuPrice}</KText>,
                ifAllSame: true,
                installmentInfo: sortedRes[0].installment,
            };
        }
        return {
            price: sortedRes[0].skuPrice,
            displayPrice: sortedRes[0].displaySkuPrice,
            node: <KText rtlClassName={'product-price-display-text'}>{sortedRes[0].displaySkuPrice}</KText>,
            ifAllSame: false,
            installmentInfo: sortedRes[0].installment,
        };
    }, [skuInfo, isAfterUsingCoupon, priceAfterCoupon.showPriceUsedCouponStyle, showAfterCouponPrice, pageRawData, selectedItems]);

    const { thresholdValue } = useInstallmentFirstThresholdValue();
    const showInstallMentFirst = useMemo(() => {
        return (
            !isToBDetail /* 达人商详页不优先展示分期信息 */ &&
            detailABValueMap.ifInstallmentAmountFirst &&
            thresholdValue <= pageRawData.itemPrice &&
            pageRawData.skus?.length === pageRawData.skuInstallments?.length
        );
    }, [
        isToBDetail,
        detailABValueMap.ifInstallmentAmountFirst,
        thresholdValue,
        pageRawData.itemPrice,
        pageRawData.skus?.length,
        pageRawData.skuInstallments?.length,
    ]);

    const renderInstallment = () => {
        return (
            <KView>
                {isAfterUsingCoupon && priceAfterCoupon.showPriceUsedCouponStyle && showAfterCouponPrice ? (
                    <KText rtlClassName={'installment-line-top'}>{$k18n({ text: '券后' })}</KText>
                ) : !immediateDisplayPrice.ifAllSame ? (
                    <KText rtlClassName={'installment-line-top'}>{$k18n({ text: '起' })}</KText>
                ) : null}
                {immediateDisplayPrice.installmentInfo ? (
                    <KView rtlClassName={'installment-line'}>
                        <KText rtlClassName={'installment-price__display-text'}>
                            {immediateDisplayPrice.installmentInfo.displayPaymentPerInstallment}
                        </KText>
                        <KText rtlClassName={'installment-month-account'}>
                            {$k18n({ text: '/期', id: 'k_405771' })}&nbsp;x&nbsp;{immediateDisplayPrice.installmentInfo.installment}
                        </KText>
                    </KView>
                ) : null}
            </KView>
        );
    };

    const renderHeaderPrice = () => {
        return showInstallMentFirst ? (
            <KView>
                {renderInstallment()}
                <KView
                    style={{"flexDirection":"row","justifyContent":"flex-start","marginTop":"0.48309178743961356rem"}}>
                    <KText rtlClassName={'product-header-price-total'}>{$k18n({ text: '总价', id: 'k_245610' })}</KText>
                    <KText rtlClassName={'product-header-price'}>
                        {!immediateDisplayPrice.ifAllSame ? fromPrice(immediateDisplayPrice.displayPrice) : immediateDisplayPrice.displayPrice}
                    </KText>
                    <KText
                        rtlClassName={'product-header-price-break-text'}
                        style={{"textDecorationColor":"#999"}}>
                        {currentSku.skuMarketPrice ? currentSku.displaySkuMarketPrice : ''}
                    </KText>
                </KView>
            </KView>
        ) : (
            <View>
                {isAfterUsingCoupon && priceAfterCoupon.showPriceUsedCouponStyle && showAfterCouponPrice ? (
                    <KText rtlClassName={'installment-line-top'}>{$k18n({ text: '券后' })}</KText>
                ) : !immediateDisplayPrice.ifAllSame ? (
                    <KText rtlClassName={'installment-line-top'}>{$k18n({ text: '起' })}</KText>
                ) : null}
                <KView rtlClassName={'product-price'}>
                    <KView rtlClassName={['product-price-display', currentSku.skuMarketPrice ? 'product-price-display-limit-width' : '']}>
                        {immediateDisplayPrice.node}
                    </KView>
                    <KView rtlClassName={'product-price-break'}>
                        <KText rtlClassName={'product-price-break-text'} style={{"textDecorationColor":"#999"}}>
                            {currentSku.skuMarketPrice ? currentSku.displaySkuMarketPrice : ''}
                        </KText>
                    </KView>
                </KView>
            </View>
        );
    };
    const specHeaderImageSource = isNotAllImg ? specImageUrls[0] : specImageUrls[specImageIndex === -1 ? 0 : specImageIndex + 1];

    const renderSpecHeader = () => {
        function goDetail(url) {
            logClickGoToDetail();
            openUrl({ url, halfWebview: true });
        }

        return (
            <KView rtlClassName={'spec_header'}>
                <KView>
                    <KTouchableWithoutFeedback onPress={() => clickImgPre()}>
                        <KView rtlClassName={'spec_header_img_wrapper'}>
                            {/* <KImage
                                rtlClassName={'spec_header_img'}
                                source={{ uri: specHeaderImageSource }}
                                cropOption={{ ratio: 0.5 }}
                            /> */}
                            <CropImage
                                className={Styles.spec_header_img}
                                src={isNotAllImg ? specImageUrls[0] : specImageUrls[specImageIndex === -1 ? 0 : specImageIndex + 1]}
                                cropOption={{ ratio: 0.5, width: 79, height: 79 }}
                                width={79}
                                height={79}
                                logParams={{
                                    itemId: pageRawData?.itemId,
                                    position: 'spec-line-pop',
                                }}
                            />
                        </KView>
                    </KTouchableWithoutFeedback>
                </KView>
                <KView rtlClassName={'infos'}>
                    {renderHeaderPrice()}
                    <View>
                        <KView rtlClassName={'infos_spec'} style={{"width":"63.76811594202899rem"}}>
                            {selectedItemsLabels ? (
                                <KText numberOfLines={2} ellipsizeMode={'tail'} rtlClassName={'skuspecdesc-text'}>
                                    {selectedItemsLabels}
                                </KText>
                            ) : (
                                <KText rtlClassName={'tip-text'}>{$k18n('请选择规格')}</KText>
                            )}
                        </KView>
                        {showDetailUrl ? (
                            <KTouchableWithoutFeedback onPress={() => goDetail(showDetailUrl)}>
                                <KView style={{"display":"flex","flexDirection":"row"}}>
                                    <KText numberOfLines={1} ellipsizeMode={'tail'} rtlClassName={'tip-text'}>
                                        {$k18n({ id: 'fa8b956e5096d04a349fb115253d75f9', text: '商品详情' })}
                                    </KText>
                                    <Image style={{"width":"5.797101449275363rem","height":"5.797101449275363rem","opacity":0.4,"transform":[{"rotate":"-90deg"}]}} source={IconDown} />
                                </KView>
                            </KTouchableWithoutFeedback>
                        ) : null}
                    </View>
                </KView>
            </KView>
        );
    };

    const imageForView = useMemo(() => {
        if (specImageUrls.length) {
            return specImageUrls.map(url => {
                return {
                    url,
                    props: {},
                };
            });
        }
        return [];
    }, [specImageUrls]);

    useImperativeHandle(
        ref,
        () => {
            return {
                selectItem,
                immediateAvailableQuantity,
                buyNow,
                specHeaderImageSource,
                closeSpec,
            };
        },
        [specHeaderImageSource]
    );
    // 关闭弹窗
    const onHandleCloseSpec = () => {
        resetAlertVisibleType();
        setPurchaseQuantity(minNum);
        closeSpec();
    };

    const onChangeImageView = idx => {
        const type = specs[0];
        const level = 0;

        // index 切换到1 就相当于点击了第一个规格
        if (idx > 0) {
            const index = idx - 1;
            const item = specs[0].itemSpecValues[index];
            selectItem(item, type, level, index);
        } else if (idx === 0) {
            setSpecImageIndex(-1);
            selectedKV[selectionList?.[0]?.value] = null;
            setSelectedKV({ ...selectedKV });
            setCurrentSku({});
            clearFirstLineSpec();
        }
        logClickImgFullSwitch(idx);
    };

    const [bottomPosition, setBottomPosition] = useState(0);

    // 这部分逻辑是为了适配rnios的可拖拽半屏吸底
    const checkIsHalfByBridgeAsync = async () => {
        const isHalfPage = containerHeightState.pageStatus === 'halfScreen';
        // 印尼krn不需要设置bottom
        if (autoBottomGap) {
            setBottomPosition(0);
        } else if (isHalfPage && isIOS) {
            console.log('isHalfPage', isHalfPage, foldRatio);
            const foldRatioNum = foldRatio ? Number(foldRatio) : 1;
            setBottomPosition(Dimensions.get('window').height * (1 - foldRatioNum));
        } else {
            setBottomPosition(0);
        }
    };

    useEffect(() => {
        containerHeightState.init && checkIsHalfByBridgeAsync();
    }, [isPopVisible, foldRatio, containerHeightState.init]);

    const onSlidingStatusChange = data => {
        const res = JSON.parse(data);
        if (res.status === 4) {
            onHandleCloseSpec();
        }
        // status 3 全屏； 4 半屏； 1 容器拖拽中
        // {"status":3,"availableSize":{"width":414,"height":896},"rect":{"y":0,"x":0,"width":414,"height":896},"safeArea":{"bottom":34,"top":48,"left":0,"right":0}}
    };

    useEffect(() => {
        yoda.event.addEventListener('krn_bottom_sheet_on_sliding_status_change', onSlidingStatusChange, ({ result }) => {
            // addEventListener bridge 本身是否调用成功
            if (result === 1) {
                // 成功
                console.log('addEventListener success');
            } else {
                // 失败
                console.log('addEventListener failed');
            }
        });
    }, []);

    const position = useFixedPosition();

    // 备注 这部分逻辑是解决半屏弹窗层级问题 需要配合组件库最新版本
    // 底部购买按钮 z-index 为 600
    // 三个z-index
    const popUpProps = () => {
        if (isFrom === 'detail-coudan') {
            return {
                maskZindex: 550,
                boxStyle: { position },
            };
        }
        return {};
    };
    const popUpPropsImagePreview = () => {
        if (isFrom === 'detail-coudan') {
            return {
                maskZindex: 650,
                boxStyle: { position },
            };
        }
        return {};
    };

    const ImgPreview = (
        <ImagePreview
            autoPlay={false}
            useScrollView={true}
            maskZindex={150}
            {...popUpPropsImagePreview()}
            customCloseIcon={active => {
                return (
                    <View style={{"position":"absolute","width":"24.154589371980677rem","height":"24.154589371980677rem","paddingLeft":"4.830917874396135rem","paddingTop":"8.212560386473431rem","zIndex":10}}>
                        <MyImage imageSrc={CloseWithBackground} styleObj={{ width: 42, height: 42 }} />
                    </View>
                );
            }}
            customStyle={{ indicatorTop: 44 }}
            images={imageForView.map((item: any) => item.url)}
            beforeClose={() => {
                setSlideBack(true);
                setShowImageViewer(false);
            }}
            // 如果没有规格图，只展示一张商品主图，这时候startPosition需要单独设置成0
            startPosition={specImageUrls.length > 1 ? specImageIndex + 1 : 0}
            onChange={onChangeImageView}
            visible={showImageViewer}
            closeable
            closeIconPosition={'top-left'}
            // closeIcon={{ uri: 'https://aws-static.kwai.net/udata/pkg/proweb/shop/c/swipeleft.3a47309cfa69d1fd.png' }}
            onClose={() => {
                setSlideBack(true);
                setShowImageViewer(false);
            }}
            boxStyle={{ zIndex: 999, ...(isFixedViewSupport ? {} : { position }) } as ViewStyle}
            loop={true}
            cropOption={{ ratio: 0.5 }}
            customCover={active => {
                return specImageIndex >= 0 && specs[0] && specs[0].itemSpecValues[specImageIndex] ? (
                    <View
                        style={{"position":"absolute","width":"100.00000000000001rem","bottom":"20%","left":"0rem","display":"flex","alignItems":"center"}}>
                        <View
                            style={{"paddingTop":"1.9323671497584543rem","paddingBottom":"1.9323671497584543rem","paddingLeft":"1.9323671497584543rem","paddingRight":"1.9323671497584543rem","display":"flex","alignItems":"center","backgroundColor":"rgba(0, 0, 0, 0.32)","borderRadius":"2.8985507246376816rem"}}>
                            <Text style={{"color":"#fff","fontWeight":"bold","fontSize":"3.381642512077295rem"}}>
                                {specs[0].itemSpecValues[specImageIndex].specValueName}
                            </Text>
                        </View>
                    </View>
                ) : null;
            }}
        />
    );

    const fixedState = useIosFixedNativeID();
    const openSlideFullScreen = useQuery<string>('openSlideFullScreen');
    const popupContent = () => {
        // 这里使用containerHeightState.init是为了防止容器状态没拿到和拿到状态后导致组件闪动。
        return pageRawData && pageRawData.specs && containerHeightState.init ? (
            <PageContext.Provider value={{ Styles }}>
                <KView
                    rtlClassName={'spec'}
                    style={[
                        {
                            bottom: bottomPosition,
                            height: '75vh',
                            width: isMobileDeviceValue ? '100vw' : PCMaxWidth,
                            position,
                        },
                        isFixedViewSupport
                            ? {
                                  bottom: 0,
                                  position: 'relative',
                                  height: containerHeightState.pageStatus === 'halfScreen' ? containerHeightState.height : windowHeight * 0.75,
                                  marginBottom: (isAndroid ? containerHeightState.pageStatus === 'halfScreen' : +openSlideFullScreen === 1)
                                      ? windowHeight - containerHeightState.height
                                      : 0,
                              }
                            : {},
                    ]}
                    nativeID={!isFixedViewSupport ? fixedState.nativeID : ''}>
                    <KView rtlClassName={'spec-close-top-right'}>
                        {/* ViewVisible直接包裹popup子元素无法触发曝光埋点，改为包裹孙子元素 */}
                        <ViewVisible
                            onVisible={
                                props.type === 'buy'
                                    ? logShowHalfSpecPage
                                    : () =>
                                          onSpecAddCartVisible({
                                              type: addType,
                                              // 如果是reco商品打开的规格半屏，source需要是recommend
                                              source: Number(queryItemId) === Number(pageRawData.itemId) ? 'current' : isReco ? 'recommend' : '',
                                              releated_item_id: String(queryItemId),
                                          })
                            }>
                            <KTouchableWithoutFeedback onPress={() => onHandleCloseSpec()}>
                                <KView rtlClassName={'spec-close-top-right-img-wrapper'}>
                                    <MyImage imageSrc={ClosePng} styleObj={{ width: 24, height: 24 }} />
                                </KView>
                            </KTouchableWithoutFeedback>
                        </ViewVisible>
                    </KView>
                    {renderSpecHeader()}
                    <RenderSpecSelectArea
                        specImageIndex={specImageIndex}
                        selectionList={selectionList}
                        pageRawData={pageRawData}
                        selectedKV={selectedKV}
                        selectItem={selectItem}
                        triggerImagePreview={clickImgPre}
                        immediateAvailableQuantity={immediateAvailableQuantity}
                        currentSku={currentSku}
                        purchaseQuantity={purchaseQuantity}
                        setPurchaseQuantity={setPurchaseQuantity}
                        showChangeCount={showChangeCount}
                        showUpStepper={showUpStepper}
                        isPopVisible={isPopVisible}
                    />
                    {renderOptionBarButton()}
                </KView>
            </PageContext.Provider>
        ) : null;
    };
    const PopupNode = (
        <Popup
            lockScroll={true}
            visible={isPopVisible}
            duration={customDuration || 150}
            onClose={() => onHandleCloseSpec()}
            position="bottom"
            style={[
                {
                    zIndex: 999,
                    width: isMobileDeviceValue ? '100%' : PCMaxWidth,
                },
                popupStyle,
            ]}
            {...popUpProps()}
            {...(isFixedViewSupport
                ? {
                      boxStyle: { zIndex: 900 },
                  }
                : {})}>
            {popupContent()}
        </Popup>
    );
    const FinalNode = isAndroid ? PopupNode : showImageViewer ? null : PopupNode;
    return isPopVisible ? (
        <>
            {FinalNode}
            <HorizontalGestureConflictView>{ImgPreview}</HorizontalGestureConflictView>
        </>
    ) : null;
});

// function areEqual(prevProps, nextProps) {
//     /*
//     如果把 nextProps 传入 render 方法的返回结果与
//     将 prevProps 传入 render 方法的返回结果一致则返回 true，
//     否则返回 false
//     */
//     console.log(prevProps, nextProps);
//     return true;
// }
// export default memo(SpecLine, areEqual);
// SpecLine.whyDidYouRender = {
//     logOnDifferentValues: true,
//     titleColor: 'red',
//     diffNameColor: 'red',
// };
export default SpecLine;
